module.exports = __webpack_public_path__ + "91411b0cb3e7ea6c78a8edb5faef8e21.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-right-18.png
// module id = 2697
// module chunks = 0